
<template>
  <section class="agency-signUp-main-sec">
    <div class="container-fluid">
      <div class="row align-item-cemter">
        <div class="col-md-6">
          <div class="responsive-logo">
            <router-link class="desktopLogo" :to="{ path: '/login', query: authNavQuery }" ><img src="@/assets/common/images/lbhq-logo.svg" />
            </router-link>
          </div>
          
          <router-link class="desktopLogo" :to="{ path: '/login', query: authNavQuery }" >
            <img src="@/assets/common/images/lbhq-logo.svg" />
          </router-link>
          <div class="form-box signIn-form-box">
            <div class="text-heading">Set New Password</div>
            <div v-if="status" class="alert alert-success">
              {{ status }}
            </div>
            <div v-if="tokenError" class="alert alert-danger" role="alert">
              {{ tokenError }}
            </div>
            <form> 
              <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input
                  v-bind:type="[showPassword ? 'text' : 'password']"
                  @keyup.enter="handleEnterKey"
                  v-model="data.password"
                  class="form-control"
                  id="exampleInputPassword1"
                  maxlength="64"
                />
                <span class="eye-icon" @click="showPassword = !showPassword">
                  <i
                    class="fa"
                    :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"
                  ></i>
                </span>
                <span
                  v-if="errors.password"
                  class="invalid-feedback"
                  style="display: block"
                  role="alert"
                >
                  <strong>{{ errors.password[0] }}</strong>
                </span>
              </div>
              <div class="form-group">
                <label for="exampleInputPassword2">Confirm Password</label>
                <input
                  v-bind:type="[confirmShowPassword ? 'text' : 'password']"
                  @keyup.enter="handleEnterKey"
                  v-model="data.password_confirmation"
                  class="form-control"
                  id="exampleInputPassword2"
                  maxlength="64"
                />
                <span
                  class="eye-icon"
                  @click="confirmShowPassword = !confirmShowPassword"
                >
                  <i
                    class="fa"
                    :class="[confirmShowPassword ? 'fa-eye-slash' : 'fa-eye']"
                  ></i>
                </span>
                <span
                  v-if="errors.password_confirmation"
                  class="invalid-feedback"
                  role="alert"
                  style="display: block"
                >
                  <strong>{{ errors.password_confirmation[0] }}</strong>
                </span>
              </div>
              <button
                type="button"
                class="btn-1"
                @click="reset"
                :disabled="!seen || isLoading"
              >
                {{ button.text }}
                <b-spinner small v-show="isLoading"></b-spinner>
              </button>
              
              <div class="sign-in-text">
                Back to sign in?
                <router-link to="login">Sign in</router-link>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-6">
          <ContentBoxComponent></ContentBoxComponent>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
</style>

<script>

import ContentBoxComponent from "@/components/ContentBoxComponent.vue";
import { withRouteRef } from "@/utils/affiliateRef";
export default {
name: 'ResetView',
  components: {
      ContentBoxComponent
    },
  mounted() {
    const token = this.getResetToken();
    if (token) {
      this.data.reset_password_code = token;
      this.seen = true;
    } else {
      // New reset links use `#token=...`; old links used `?token=...`.
      // If neither exists, we avoid calling the backend with an empty token.
      this.seen = false;
      this.tokenError = "Invalid or expired reset link";
    }

      window.document.body.style.paddingLeft = '0px';
  },
  props: ["token"],

  data() {
    return {
      data: {
      reset_password_code : '',
      password: "",
      password_confirmation: "",
      },
      showPassword: false,
      confirmShowPassword: false,
      isLoading: false,
      tokenError: "",
      errors: {
        email: [],
        password: [],
      },
      button: {
        text: "Reset",
      },
      seen: true,
      status: false,
    };
  },
  computed: {
    authNavQuery() {
      return withRouteRef(this.$route.query);
    },
  },
  methods: {
      validatePasswordLength() {
        const password = String(this.data.password || "");
        const confirmation = String(this.data.password_confirmation || "");
        let hasError = false;

        if (password.length > 64) {
          this.errors.password = ["Password may not be greater than 64 characters."];
          hasError = true;
        }
        if (confirmation.length > 64) {
          this.errors.password_confirmation = [
            "Confirm password may not be greater than 64 characters.",
          ];
          hasError = true;
        }
        return !hasError;
      },
      getResetToken() {
        let token = null;
        // New format: #token=...
        if (window.location.hash) {
          const hashParams = new URLSearchParams(window.location.hash.substring(1));
          token = hashParams.get('token');
        }
        // Fallback: ?token=... (for backward compatibility)
        if (!token) {
          const urlParams = new URLSearchParams(window.location.search);
          token = urlParams.get('token');
        }
        return token;
      },
      handleEnterKey() {
      this.reset();
    },
    async reset() {
        if (!this.validatePasswordLength()) {
          return;
        }
        if (!this.data.reset_password_code) {
          this.tokenError = "Invalid or expired reset link";
          return;
        }
      this.isLoading = true;
      try {
        let res = await this.$store.dispatch("Auth/resetPasswordAction", this.data, {
         root:true
        });
        if(res.success){
          this.isLoading = false;
          this.status = res.message;
          this.$router.push("/dashboard");
        }
      } catch (error) {
        this.isLoading = false;
        this.errors = error.response.data.errors; 
        
      }
    },

    },
};
</script>
